var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"tagName":"div","type":"onestoreSubscribePrivacy"}},[_c('a',{staticClass:"subscribe-privacy j-subscribe-privacy",on:{"click":_vm.jumpPrivacyLink}},[_vm._v(_vm._s(_vm.languages.onestore_subscribe_privacy))])])}
var staticRenderFns = []

export { render, staticRenderFns }